<template>
	<div>
		<component
		v-if="component && userCanViewField"
		:is="component"
		:field="field"
		:editing="editing"
		:readonly="readonly || (!userCanCompleteField && !editing)"
		:formresponse="formresponse"
		/>
	</div>
</template>

<script>
export default {
	name: 'FormField',
	props: [
		'field',
		'type',
		'editing',
		'readonly',
		'viewAs',
		'formresponse'
	],
	data() {
		return {
			component: null,
		};
	},
	watch: {
		type: function () {
			this.loader()
				.then(() => {
					this.component = () => this.loader()
				})
		}
	},
	mounted() {

		this.loader()
			.then(() => {
				this.component = () => this.loader()
			})
			/*.catch(() => {
				//this.component = () => import('templates/default')
			})*/

	},
	computed: {
        loader() {
            if (!this.type) {
                return null
            }
            return () => import(`./templates/${this.type}`)
        },
		userCanCompleteField() {
			if(this.viewAs) {
				return  !('permission' in this.field) || this.field.permission.length == 0
				|| this.field.permission.includes(this.viewAs) || this.viewAs === 'editall'
			} else {
				return false
			}/*else {
				return this.field.permission === []
				|| (this.$UserSession.hasPriv('TREATMENTSESSION_MANAGE') && this.field.permission == 'submitter')
				|| (this.$UserSession.hasPriv('TREATMENTSESSION_MANAGE') && this.field.permission == 'reviewer')
				|| (this.$UserSession.hasPriv('TREATMENTSESSION_MANAGE') && this.field.permission == 'signer')
			}*/
		},
		userCanViewField() {
			return !this.field.hideifcantcomplete || this.userCanCompleteField || this.editing || (this.field.showaftersignoff && this.formresponse && this.formresponse.formresponse_signedoff == '1') ||  (this.field.showafterreview && this.formresponse && this.formresponse.formresponse_reviewed == '1');
		}
	},
};
</script>
